import Decimal from 'decimal.js';
import PendingIcon from '../../assets/icons/pending.svg?react';
import {
  PENDING_BALANCE,
  PENDING_BALANCE_TXN,
  PENDING_BALANCE_NFT,
  PENDING_NFT,
  FEE_DECIMAL_PLACES,
} from '../../utils/config';

/**
 * Popup component to display transaction status, fee, and balance details.
 * It is conditionally rendered based on the `isOpen` state.
 *
 * @returns {JSX.Element | null} The rendered popup or null if not open.
 */
const NFTModal = ({ message, fee, balance, pendingIsOpen, setPendingIsOpen }) => {
  if (!pendingIsOpen) return null; // Don't render if the popup isn't open
  /**
   * Determines the step number based on the provided message.
   * @param {string} message - The current message of the popup.
   * @returns {string} The step number string.
   */
  const stepNumber = (message: string) => {
    if (message === PENDING_BALANCE_TXN || message === PENDING_BALANCE) {
      return '1 / 2';
    }
    if (message === PENDING_BALANCE_NFT || message === PENDING_NFT) {
      return '2 / 2';
    }
  };
  const stepDetails = (message) => {
    if (message === PENDING_BALANCE_TXN || message === PENDING_BALANCE) {
      return 'Fee Payment';
    }
    if (message === PENDING_BALANCE_NFT || message === PENDING_NFT) {
      return 'NFT Minting';
    }
    return '';
  };

  const cancelPayment = () => {
    setPendingIsOpen(false);
  };

  if (balance) {
    //console.log('Balance/Popup:', balance);
  }
  //   <div className=" flex flex-col h-full w-full items-center gap-4  ">
  //   {/* Spacer div to push content to center to bottom */}
  //   <div className="flex-grow"></div>
  //   <p className="text-[22px] font-normal">test</p>
  //   <div className="text-2xl">
  //     <img src={pendingIcon} style={{ width: '64px' }} />
  //   </div>
  //   content
  //   {/* Spacer div to push button to bottom */}
  //   <div className="flex-grow"></div>
  //   <button
  //     className="w-full h-[48px] py-4 px-8 flex justify-center items-center bg-minima-orange-2023 text-black
  //   hover:bg-minima-orange-light transition-colors duration-600 ease-in-out"
  //   >
  //     Close
  //   </button>
  // </div>
  return (
    <div className="flex flex-col h-full w-full items-center justify-center gap-4">
      {/* Spacer div to push content to center to bottom */}
      <div className="flex-grow"></div>
      <PendingIcon className="w-16 h-16" />
      {/* <p> {stepNumber(message)}</p> */}
      {/* <h3 className="text-lg font-medium">{stepDetails(message)}</h3> */}
      <h2 className="text-[22px]">{message}</h2>
      <p className="text-[14px] text-center">
        {message === PENDING_BALANCE || message === PENDING_NFT
          ? 'Please open your ‘Pending’ minidapp and confirm your transaction.'
          : ''}
      </p>
      {/* <p>Fee:</p>
      <p>Balance:</p>
      <p>Pending balance:</p> */}

      {/* <p>{new Decimal(fee).toFixed(FEE_DECIMAL_PLACES)}</p> */}
      {/* {balance && (
        <>
          <p>{Number(balance.sendable).toFixed(1)}</p>
          <p>{Number(balance.unconfirmed).toFixed(1)}</p>
        </>
      )} */}
      {/* Spacer div to push button to bottom */}
      <div className="flex-grow"></div>
      <button
        className="w-full h-[48px] py-4 px-8 flex justify-center items-center bg-minima-orange-2023 text-black
           hover:bg-minima-orange-light transition-colors duration-600 ease-in-out"
        onClick={() => cancelPayment()}
      >
        Cancel
      </button>
    </div>
  );
};

export default NFTModal;
